import { Navigate, Route, Routes } from 'react-router-dom'
import AppLayout from '../components/layout/AppLayout'
import Home from '../pages/Home'
import Trade from '../pages/Trade'
import Connect from '../pages/Connect'
import Portfolio from '../pages/Portfolio'
import PublicPools from '../pages/PublicPools'
import Staking from '../pages/Staking'
import Referrals from '../pages/Referrals'
import FundingMarketRisk from '../pages/FundingMarketRisk'
import SubAccounts from '../pages/SubAccounts'
import { RouteErrorBoundary } from "../components/layout/RouteError";

export default function Router() {
  return (
    <RouteErrorBoundary>
      <Routes>
      <Route element={<AppLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/connect" element={<Connect />} />
        <Route path="/trade" element={<Navigate to="/trade/LIT" replace />} />
        <Route path="/trade/:symbol" element={<Trade />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/public-pools" element={<PublicPools />} />
        <Route path="/staking" element={<Staking />} />
        <Route path="/referrals" element={<Referrals />} />
        <Route path="/sub-accounts" element={<SubAccounts />} />
        <Route path="/funding-market-risk-parameters" element={<FundingMarketRisk />} />
      </Route>
    </Routes>
    </RouteErrorBoundary>
  )
}
